window.onload = ()=>{
    email.onmousedown = ()=>{
        email.href = window["atob"]("bWFpbHRvOmsydHR5Y2F0QGdtYWlsLmNvbQ==");
    };
    email.onmouseleave = ()=>{
        email.href = "mailto:hell@naw.com";
    };
};

//# sourceMappingURL=path0.4dd66b5f.js.map
